/* eslint-disable no-shadow */
import NProgress from 'nprogress/nprogress';
import api from './api';

export const state = {
  recaptchaSuccess: false,
};

export const getters = {
  getRecaptchaSuccess(_state) {
    return _state.recaptchaSuccess;
  },
};

export const mutations = {
  SET_RECAPTCHA_SUCCESS(_state, success) {
    _state.recaptchaSuccess = success;
  },
};

export const actions = {
  validateRecaptcha({ commit }, token) {
    NProgress.start();

    return api.Integrations.validateRecaptcha(token)
      .then(({ data }) => {
        commit('SET_RECAPTCHA_SUCCESS', data.success);

        return Promise.resolve(data.success);
      }).finally(() => {
        NProgress.done();
      });
  },
};
